import React from 'react';
import { Image } from 'react-bootstrap';
import InformationIcon from '../assets/icon/information.svg';

const Aceitar: React.FC<any> = () => {
  return (
    <div className="position-relative h-100">
      <div
        className="w-100 d-flex align-items-center justify-content-between ps-3"
        style={{
          backgroundColor: '#1A1A1A',
        }}
      >
        <div className="d-flex align-items-center">
          <Image
            src={InformationIcon}
            style={{ width: '1.6rem', height: '1.6rem' }}
            alt="Configurações"
          />
          <span
            className="text-white ms-2"
            style={{
              fontSize: '1.68rem',
              fontWeight: '600',
              backgroundColor: '#1A1A1A',
            }}
          >
            Sobre
          </span>
        </div>
      </div>
      <div className="mt-3 d-inline-block">
        <Image
          src={`${process.env.PUBLIC_URL}/logoLiveChat.svg`}
          style={{ height: '16rem', width: '25rem' }}
          alt="Logo"
        />
      </div>
      <div className="ms-2 mt-2 d-flex flex-column">
        <span style={{ fontSize: '2rem', fontWeight: '600' }}>
          CS Live - Chat
        </span>
        <span style={{ fontSize: '1.2rem' }}>1.0.0</span>
        <div>
          <span style={{ fontSize: '1.2rem' }}>
            Para verificar as atualizações:
          </span>
          <a
            className="ms-2"
            style={{ color: '#267DFF' }}
            href="https://csoftware.com.br"
            target="_blank"
            rel="noreferrer"
          >
            <span style={{ fontSize: '1.2rem', fontWeight: '600' }}>
              CSoftware
            </span>
          </a>
        </div>
      </div>
      <div className="d-flex flex-column position-absolute bottom-0 start-0 end-0 bg-light p-3 d-flex justify-content-center align-items-center">
        <span style={{ fontSize: '1.1rem', fontWeight: '600' }}>
          desenvolvido por
        </span>
        <Image
          src={`${process.env.PUBLIC_URL}/logo_c_software_Cliente.png`}
          className="mx-2 my-2"
          style={{ height: '4rem', width: '14rem' }}
          alt="Logo"
        />
      </div>
    </div>
  );
};

export default Aceitar;
